import React from 'react';
import { Text } from '@mantine/core';

import { FormValues } from './useForgotPasswordEmail';
import { UseFormReturnType } from '@mantine/form';
import { Link } from 'react-router-dom';

interface ForgotPasswordEmailSuccessProps {
  reset: () => void;
  form: UseFormReturnType<FormValues>;
}
const ForgotPasswordEmailSuccess: React.FC<ForgotPasswordEmailSuccessProps> = ({ reset, form }) => {
  return (
    <>
      <Text fz="2rem" fw="bold" mt="md">
        Password Reset Email Sent!
      </Text>
      <Text mt="md">
        We've sent an email to: <strong>{form.values.email}</strong>
      </Text>
      <Text mt="sm">
        You should receive an email to reset your password within the next 10 minutes.
      </Text>
      <Text mt="sm">
        If you don't see one come through your inbox, please{' '}
        <Link to="/forgot_password/email" onClick={reset}>
          try again
        </Link>{' '}
        or get in touch with your Fooda contact.
      </Text>
    </>
  );
};

export default ForgotPasswordEmailSuccess;
